import { listen, qs, remove } from '@fluorescent/dom';

import { section } from '@/glow';

const selectors = {
  wrapper: '.video__wrapper',
  overlay: '.video__overlay',
  player: '.video__player',
  button: '[data-video-trigger]',
};

section('video', {
  onLoad() {
    import('@fluorescent/video').then(({ default: Video }) => {
      const videoWrapper = qs(selectors.wrapper, this.container);

      if (!videoWrapper) return;

      const { videoId, videoType } = videoWrapper.dataset;

      if (!videoId || !videoType) return;

      const overlay = qs(selectors.overlay, this.container);
      const player = qs(selectors.player, this.container);
      const button = qs(selectors.button, this.container);

      this.video = Video(this.container, {
        id: videoId,
        type: videoType,
        playerEl: player,
      });

      this.video.on('play', () => {
        remove(overlay, 'visible');
      });

      this.playClick = listen(button, 'click', e => {
        e.preventDefault();

        this.video.play();
      });
    });
  },

  onUnload() {
    this.video && this.video.destroy();
    this.playClick && this.playClick();
  },
});
